export default __webpack_public_path__ + "static/media/OUTLND-Profile.4d3d0d81.png";